import { render, staticRenderFns } from "./ParentalInfo.vue?vue&type=template&id=6cafe12c&scoped=true&"
import script from "./ParentalInfo.vue?vue&type=script&lang=js&"
export * from "./ParentalInfo.vue?vue&type=script&lang=js&"
import style0 from "./ParentalInfo.vue?vue&type=style&index=0&id=6cafe12c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cafe12c",
  null
  
)

export default component.exports